<template>
	<div class="template_box">
		<div class="content_box" @click="closePopup()">
			
			<div class="navigation_box">
				<div class="navigation">
					<div class="navigation_div" :class="getClassName(navigation_list[0])" @click="menuChange('menuChange1')">
						<div id="nav_text2" class="nav_text">{{navigation_list[0].title}}</div>
					</div>
					<div class="border_text" v-if="navigation_list[0].id != 4">...</div>
					
					<div class="navigation_div" :class="getClassName(navigation_list[1])" @click="menuChange('menuChange2')">
						<div id="nav_text2" class="nav_text">{{navigation_list[1].title}}</div>
					</div>
					<div class="border_text" v-if="navigation_list[1].id != 4">...</div>
					
					<div class="navigation_div" :class="getClassName(navigation_list[2])" @click="menuChange('menuChange3')">
						<div id="nav_text2" class="nav_text">{{navigation_list[2].title}}</div>
					</div>
					<div class="border_text" v-if="navigation_list[2].id != 4">...</div>
					
					<div class="navigation_div" :class="getClassName(navigation_list[3])" @click="menuChange('menuChange4')">
						<div id="nav_text2" class="nav_text">{{navigation_list[3].title}}</div>
					</div>
					<div class="border_text" v-if="navigation_list[3].id != 4">...</div>
				</div>
			</div>
			
			<el-form ref="form_data" :model="detail_data" :rules="rules" label-width="0px" label-position="left" class="form_data">
				<div class="Choose_a_gift margin_top menuChange1">
					<div class="title_text">1、选择礼品<span class="red">*</span></div>
					<el-form-item label="" label-width="0px" prop="gift_name">
						<div class="gift_box">
							<div class="img_box" v-for="(item, index) in productList" :key="item.id" @click="selectProduct(item)">
								<div class="img" :class="detail_data.gift_name == item.product_name ? 'img_border' : 'no_select'"><img :src="item.product_src" /></div>
								<div class="prize" :class="detail_data.gift_name == item.product_name ? 'color_FFD89D' : ''">{{ item.product_name }}</div>
							</div>
						</div>
					</el-form-item>
				</div>
			
				<div class="order_box margin_top menuChange2">
					<div class="title_text">2、填写订单<span class="red">*</span></div>
						<div class="form-top">
							<el-form-item label="" label-width="0px" prop="order_no">
								<el-input v-model.trim="detail_data.order_no" type="text" :disabled="editable" :maxlength="30" placeholder="实例订单号: 123-1234-12345" @blur="Lost_Focus_blur(2, 'order_no')"/>
							</el-form-item>
					  </div>
				</div>
				
				<div class="order_box margin_top menuChange3">
					<div class="title_text">3、评价晒图（最多3张图片，20M以内）<span class="red">*</span></div>
					<div class="form-top">
						<!-- 上传图片 -->
						<el-form-item label="" label-width="0px" prop="pics" v-if="!editable">
						  <UploadImage v-model="detail_data.pics" :upload_type="typeImg":bg_color="bg_color" style="margin-right: 10px;" :imgList="order_img" @remove_img_url='remove_img_url' @save_img_url='save_img_url'/>
						</el-form-item>
						<!-- 查看图片 -->
						<el-image
						  v-else
						  v-for="(item, index) in this.order_img"
						  :key="index"
						  style="width: 90px; height: 90px;border: 1px #999999 solid;margin: 3px; border-radius: 6px;"
						  fit="contain"
						  :src="item.url"
						  lazy
						  :preview-src-list="[item.url]">
						</el-image>
					</div>
				</div>
				
				<div class="order_box margin_top menuChange4">
					<div class="title_text">4、填写地址<span class="red">*</span></div>
					<div class="form-top">
						<el-form-item label="姓名" label-width="80px" prop="name">
							<el-input v-model="detail_data.name" type="text" :disabled="editable" :maxlength="20" placeholder="" @blur="address_blur(4, 'name')"/>
						</el-form-item>
						
						<el-form-item label="手机号" label-width="80px" prop="phone">
							<el-input v-model.trim="detail_data.phone" type="text" :disabled="editable" :maxlength="11" placeholder="" @blur="address_blur(4, 'phone')"/>
						</el-form-item>
						
						<el-form-item label="地区" label-width="80px" prop="area">
							<div class="class_select">
								<div class="select" @click.stop="handleInputClick()" :class="detail_data.area == '' ? 'select_red' : (editable ? 'select_999999' : 'select_DCDFE6')">
									{{ detail_data.area }}
									<span class="el-input__suffix-inner suffix_" :class="popupShow ? 'suffix_select' : 'suffix_no'">
										<i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
									</span>
								</div>
							</div>
						</el-form-item>
						
						<!-- <div class="Provincial">
							<el-form-item label="地区" label-width="80px" prop="area">
								<el-cascader
								   v-model="detail_data.area"
									:disabled="editable"
								   :options="regionOptions"
								   placeholder="请选择省市区"
									:clearable="true"
								   @change="handleRegionChange"
								></el-cascader>
							</el-form-item>
						</div> -->
							 
						<el-form-item label="详细地址" label-width="80px" prop="address">
							<el-input v-model="detail_data.address" type="textarea" :rows="7" :disabled="editable" :maxlength="50" placeholder="" @blur="address_blur(4, 'address')"/>
						</el-form-item>
						<el-form-item label="邮编" label-width="80px" prop="postcode">
							<el-input v-model.trim="detail_data.postcode" type="text" :disabled="editable" :maxlength="6" placeholder="" @blur="address_blur(4, 'postcode')"/>
						</el-form-item>
					</div>
				</div>
			</el-form>
			
			<div class="btn_box">
				<div class="err_class"><span v-if="err_text">{{ err_text }}</span></div>
				<el-button v-if="!editable" type="primary" :loading="isLoading" @click="fn_save">提交</el-button>
			</div>
		</div>
		
		<div class="vanArea" v-if="popupShow">
			<van-area
				:area-list="areaList"
				v-model="detail_data.area"
				@change="changeAddr"
				title="请选择省市区/县"
				columns-num='3'
				visible-item-count='7'
			   @cancel="onCancel" 
				@confirm="onConfirm"
				confirm-button-text="确认"
				cancel-button-text="取消"
			/>
		</div>
		
	</div>
</template>

<script>	
import { postordergift, getvxuserinfo, ordergiftdetail } from "../../plugins/api.js"	
import { menuChange } from "../../plugins/menuChange.js"	
import UploadImage from "../../components/ProductImage.vue"
import { regionOptions } from './regionOptions.js';
import { navigation_list } from './navigation.js';
import { addressData } from './addressData.js';
import { rules } from './formRules.js';
import { Cascader } from 'element-ui';
import { Area, Popup, Picker } from 'vant';

export default {
	name: 'rintingDetails',
	components: { UploadImage, 'el-cascader': Cascader, 'van-area': Area, },
   data() {
		return {
			popupShow: false,
			vx_open_id:'',
			err_text:'',
			isLoading: false,
			code: '',
			productList: this.$productList,
			typeImg: "img_url",
			order_img: [],
			editable:true,
			flag_base:true,
			bg_color: '#000000',
			
			regionOptions: regionOptions,
			areaList: addressData,
			//areaList: are, //are为外部链接的json文件里的areaList名字，直接这样用就行
			//regionOptions: regionOptions,
			navigation_list: navigation_list,
			rules: rules,
			
			detail_data:{
				source: 1,
				gift_name: this.$productList[0].product_name,
				order_no:'',
				pics: [],
				
				name: '',
				phone: '',
				area: '',
				address: '',
				postcode: '',
			},
		}
   },
	
   mounted(){
		console.log(addressData)
		this.order_no = this.$route.query.order_no ? this.$route.query.order_no : '330'
		let StorageOpenid = localStorage.getItem("vx_open_id") ? localStorage.getItem("vx_open_id") : ''
		this.vx_open_id = this.$route.query.vx_open_id ? this.$route.query.vx_open_id : StorageOpenid
		
		if(this.vx_open_id){
			this.get_ordergiftdetail()
		}else{
			// 获取URL中的code参数
			const code = new URLSearchParams(window.location.search).get('code');
			this.code = code
			if (code) {
			  // 获取到code，调用接口获取vx_open_id
			  this.get_vxuserinfo(code);
			}else{
				this.$root.$emit('authorize', { url: 'rintingDetails' }); // 获取授权信息
			}
		}
		
		this.navigation_list.forEach((item)=>{
			item.complete = true
		})
   },
	
	methods: {
		//从后端获取vx_open_id
		async get_vxuserinfo(code){
			const fd = new window.FormData()
			fd.append("code", code)//微信用户vx_open_id
			await getvxuserinfo( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.vx_open_id = res.data.vx_open_id;
					localStorage.setItem('vx_open_id', this.vx_open_id)
					this.get_ordergiftdetail()
				}
			}, (err) => {
			  console.log(err)
			})
		},
		
		//关闭弹窗
		closePopup(){
			this.popupShow = false;
		},
		
		//省市区点击时获取选择的值
		changeAddr (picker) {
			//value=0改变省，1改变市，2改变区
		  let val = picker.getValues()
		  console.log(val)
		  this.resAddr = val
		},
		
		//展示收缩
		handleInputClick(){
			if(this.editable){ return }
			this.popupShow =! this.popupShow;
		},
		
		//点取消，关闭弹窗
		onCancel() {
		  this.popupShow = false;
		},
		
		//点确定，value为选择三级数据
		onConfirm(value) {
			console.log(value)
			if((value[0] && value[0].name) && (value[1] && value[1].name) && (value[2] && value[2].name)){
				var area_arr = [value[0].name, value[1].name, value[2].name]
				this.detail_data.area = area_arr.join(',');
				this.popupShow = false;
			}else if(!this.detail_data.area || this.detail_data.area == ''){
				this.popupShow = true;
			}else{
				this.popupShow = false;
			}
		   this.post_validateField('area')
		},
		
		//获取晒单详情
		get_ordergiftdetail() {
			const fd = new window.FormData()
			fd.append("vx_open_id", this.vx_open_id)//微信用户vx_open_id
			fd.append("order_no", this.order_no)//产品名称
			
			ordergiftdetail( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.detail_data = res.data
					// this.detail_data.area = res.data.area.split(","); //将字符串转为数组
					document.title = this.detail_data.source == 1 ? '天猫晒单赢奖励' : '京东晒单赢奖励' //标题
					this.get_img_url(this.detail_data.pics)
				}else{
					// this.err_text = res.message
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: res.message });
				}
			}, (err) => {
				// this.err_text = err.message
				this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: err.message });
				console.log(err)
			})
		},
		
		//转化图片地址格式
		get_img_url(pics_list){
			if(pics_list && pics_list.length != 0){
				let arr = []
				pics_list.forEach((item)=>{
					let obj = {}
					obj.url = item
					arr.push(obj)
				})
				this.order_img = arr
			}
		},
		
		// 地址信息模块验证
		address_blur(id, name) {
			if(name == 'name'){
				this.detail_data.name = this.detail_data.name.trim(); //自动去除前后空格
			}
			if(name == 'address'){
				this.detail_data.address = this.detail_data.address.trim(); //自动去除前后空格
			}
			
			let data = this.detail_data
			if(data.name && data.phone && data.area && data.address && data.postcode){
				const fieldsToValidate = ['name', 'phone', 'area', 'address', 'postcode']; // 替换为您要验证的表单元素的 ref
				let isValid = true;
						
				fieldsToValidate.forEach(fieldRef => {
					this.$refs.form_data.validateField(fieldRef, errorMsg => {
					if (errorMsg) {
					  isValid = false;
					}
					});
				});
					
				if (isValid) {
					// 所有表单元素验证通过
					this.post_navigation_list(id, 'complete')
				}else{
					this.post_navigation_list(id, 'no')
				}
			}else{
				this.post_navigation_list(id, 'no')
			}
		},
		
		// 汇集1\2\3模块判断是否完成事件
		Lost_Focus_blur(id, name){
			if(this.post_validateField(name)){
				this.post_navigation_list(id, 'complete')
			}else{
				this.post_navigation_list(id, 'no')
			}
		},
		
		// 判断是否完成显示导航栏状态
		post_navigation_list(num, type){
			this.navigation_list.forEach((item)=>{
				if(item.id == num){
					if(type == 'complete'){
						item.complete = true
					}else{
						item.complete = false
					}
				}
			})
		},
		
		// 验证指定元素事件
		post_validateField(name){
			let validate;
			this.$refs.form_data.validateField(name, (val) => {
			  if (!val) {
					validate = true
			      return true;
			    } else {
					validate = false
			      return false;
			    }
			})
			console.log(validate)
			return validate
		},
		
		// 返回
		go_back(){
			this.$router.go(-1);
		},
		
		//获取类
		getClassName(item){
			// console.log(item)
			return item.complete ? 'navigation_div_select' : 'navigation_div_no'
		},
		
		//选择奖品
		selectProduct(item){
			if(this.editable){ return }
			this.detail_data.gift_name = item.product_name
			this.Lost_Focus_blur(1, 'gift_name')
		},
		
		//地区选择
		handleRegionChange(value) {
		   console.log('选择的省市区:', value);
		},
		
		//正则验证
		validate() {
		  this.$refs.form_data.validate((valid) => {
		    if (valid) {
		      this.flag_base = true
		      return true
		    } else {
		      this.flag_base = false
		      return false
		    }
		  })
		},
		
		//提交
		fn_save() {
			// this.err_text = ''
			this.isLoading = true;
			this.validate()
			if(!this.flag_base){ 
				this.isLoading = false;
				return 
			}
			
			var obj = this.detail_data
			const fd = new window.FormData()
			
			fd.append("vx_open_id", localStorage.getItem('vx_open_id'))//微信用户vx_open_id
			fd.append("gift_name", obj.gift_name)//产品名称
			fd.append("order_no", obj.order_no)//订单号
			fd.append("name", obj.name)//姓名
			fd.append("phone", obj.phone)//手机号码
			fd.append("area", obj.area)//地区
			fd.append("address", obj.address)//详细地址
			fd.append("postcode", obj.postcode)//邮编
			fd.append("source", obj.source)//1 为天猫   2 为京东
			
			obj.pics.forEach((item, i) => {
			  console.log(item)
			  fd.append(`pics[${i}]`, item)//图集
			})
			
			postordergift( fd ).then((res) => {
				console.log(res)
				this.isLoading = false;
				
				if(res.code == 0){
					// this.err_text = ''
					this.$router.go(-1);
					if(localStorage.getItem('isWeChat') == "true"){
						this.onBackCloseWindow()
					}
					this.$root.$emit('showMessage', { messageType: 'success', messageTime: 3000, globalMessage: '提交成功' }); // 触发事件并传递消息
					
				}else{
					// this.err_text = res.message
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: res.message });
				}
			}, (err) => {
				this.isLoading = false;
				if(err.code == 4010){
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: '提交失败<br>请勿重复提交' });
				}else{
					// this.err_text = err.message
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: err.message });
				}
				console.log(err)
			})
		},
		
		//当点击返回键时，不返回到上一页，而是直接关闭微信浏览器
		onBackCloseWindow() {
			pushHistory();
		   window.addEventListener("popstate", function(e) {
		      //关闭当前浏览器或跳转重定向页面
				if(WeixinJSBridge){
					WeixinJSBridge.call("closeWindow");
				}
		   }, false);
		   function pushHistory() {
		      var state = {
		         title: "title",
		         url: "#"
		      };
		      window.history.pushState(state, "title", "#");
		   }   
		},
		
		// 新建保存的活动图
		save_img_url(data) {
			this.detail_data.pics.push(data)
			this.Lost_Focus_blur(3, 'pics')
		},
		
		// 新建删除的活动图
		remove_img_url(data) {
		  this.detail_data.pics = data
		  this.Lost_Focus_blur(3, 'pics')
		},
		
		//点击菜单跳转到指定位置
		menuChange(menuType){
			menuChange(menuType)
		},
   }
}
</script>
<style>
.el-cascader-menu {
	min-width: 120px !important;
	box-sizing: border-box;
	color: #606266;
	border-right: solid 1px #E4E7ED;
}
</style>

<style lang='less' scoped>
.class_select{
	width: 100%;
	.select_DCDFE6{
		border: 1px solid #DCDFE6;
	}
	.select_999999{
		border: 1px solid #999999;
	}
	.select_red{
		border: 1px solid #F56C6C;
	}
	.select{
		width: 100%;
		display: flex;
		justify-content: space-between;
		
		box-sizing: border-box;
		height: 40px;
		padding: 0 8px;
		font-size: 14px;
		color: #666666;
		background-color: #000;
		border-radius: 4px;
		
		.el-icon-arrow-up:before {
		   content: "\e6e1";
			color: #C0C4CC;
			font-size: 14px;
		}
		.el-input__suffix-inner{
			display: block;
			transition: transform .3s;
			.el-input__icon {
			   height: 100%;
			   width: 15px;
			}
		}
		.suffix_{
			position: absolute;
			right: 0;
			margin-right: 8px;
		}
		.suffix_select{
			transform: rotateZ(0deg) !important;
		}
		.suffix_no{
			transform: rotateZ(180deg) !important;
		}
	}
}
.vanArea{
	transition: transform 0.3s;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100vw;
}
.form_data{
	margin-top: 70px;
}
.openid{
	border: 1px red solid;
	margin-top: 20px;
	color: #ffffff;
}
.content_box{
	padding-bottom: 40px;
}
.title_text{
	font-size: 14px;
	line-height: 16px;
	text-align: left;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #FFFFFF;
}
.red{
	color: red;
}

.margin_top{
	margin-top: 40px;
	&:nth-child(1){
		margin-top: 20px;
	}
}

.gift_box{
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	.img_box{
		/* width: calc(50% - 6px); */
		/* max-width: 200px; */
		height: 100%;
		cursor:pointer;
		&:nth-child(1){
			margin-right: 12px;
		}
		.img{
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			box-sizing: border-box;
			padding: 25px;
			border-radius: 10px;
		}
		.no_select{
			border-radius: 10px;
			position: relative;
		}
		.no_select::after {
		  content: "";
		  z-index: 0;
		  position: absolute;
		  top: 0px;
		  left: 0px;
		  right: 0px;
		  bottom: 0px;
		  border-radius: 10px;
		  background-image: url('https://oss-gzh.tozo.com.cn/sunbathing/gift_default_border.png');
		  background-size: 100% 100%;
		  background-repeat: no-repeat;
		}
		.img_border{
			border-radius: 10px;
			position: relative;
		}
		.img_border::after {
		  content: "";
		  z-index: 0;
		  position: absolute;
		  top: 0px;
		  left: 0px;
		  right: 0px;
		  bottom: 0px;
		  border-radius: 10px;
		  background-image: url('https://oss-gzh.tozo.com.cn/sunbathing/gift_select_border.png');
		  background-size: 100% 100%;
		  background-repeat: no-repeat;
		}
		img{
			width: 100%;
			z-index: 2;
			max-width: 200px;
			border-radius: 10px;
		}
		.prize{
			margin-top: 10px;
			color: #666666;
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
		}
		.color_FFD89D{
			color: #FFD89D;
		}
	}
}

.form-top{
	margin-top: 15px;
	text-align: left;
}
::v-deep .el-cascader {
   width: 100%;
}
::v-deep .el-form-item__label{
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #FFFFFF;
}
::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
	 display: none;
}
::v-deep .el-input__inner::placeholder{
	color: #999999;
}
::v-deep .el-input__inner{
	height: 40px;
	padding: 0 8px;
	font-size: 14px;
	color: #666666;
	background-color: #000;
}
::v-deep .el-textarea__inner{
	padding: 0 8px;
	font-size: 14px;
	color: #666666;
	background-color: #000;
}
::v-deep .el-textarea.is-disabled .el-textarea__inner,
::v-deep .el-input.is-disabled .el-input__inner {
   background-color: #000000;
   border-color: #999999;
   color: #666666;
   cursor: not-allowed;
}

@media only screen and (max-width: 550px){
  ::v-deep .el-select {
      width: 100%;
  }
}
@media only screen and (min-width: 550px){
	.Provincial{
		width: 100%;
		display: flex;
		.el-form-item{
			flex: 1;
			margin-right: 10px;
			&:last-child{
				margin-right: 0px;
			}
		}
	}
	
	::v-deep .el-select {
      width: 100%;
	}
}
.btn_box{
	padding: 20px 0px 50px 0px;
	.err_class{
		color: red;
		margin-bottom: 10px;
		font-size: 12px;
	}
	::v-deep .el-button--primary {
	   width: 100%;
		max-width: 500px;
		height: 40px;
		background: linear-gradient(137deg, #EBB666 0%, #FFE7C3 100%);
		border-radius: 6px 6px 6px 6px;
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #000000;
		border-color: #000;
	}
}

.navigation_box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  z-index: 99;
   background-color: #000;
  .navigation{
	  width: 100%;
	  max-width: 1024px;
	  overflow: hidden;
	  color: #000000;
	  box-sizing: border-box;
	  height: 55px;
	  padding: 10px 12px!important;
	  display: flex;
	  justify-content: center;
  }
}
.border_text{
	color: #ffffff;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 10%;
	margin-top: -6px;
}
.navigation_div{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 4px;
  width: calc(90%);
  height: 100%;
}
.nav_text{
   font-size: 12px;
   font-family: Poppins-SemiBold, Poppins;
   font-weight: 600;
   line-height: 15px;
}
.navigation_div_select{
	background: linear-gradient(to right, #EBB666, #FFE7C3);
	font-size: 12px;
	font-family: PingFang SC-Heavy, PingFang SC;
	font-weight: 800;
	color: #000000;
}
.navigation_div_no{
	font-size: 12px;
	font-family: PingFang SC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	border: 1px solid #666666;
}
.navigation_div_1{
  background: 
	linear-gradient(135deg, transparent 0px, #999 0) top left,
   linear-gradient(45deg, transparent 0px, #999 0) bottom left,
   linear-gradient(-45deg, transparent 12px, #999 0) bottom right,
   linear-gradient(-135deg, transparent 12px, #999 0) top right !important;
   background-size: 80% 50.1% !important;
   background-repeat: no-repeat !important;
   box-sizing: border-box;
   padding: 0 0px 0px 0px!important;
	.nav_text{
	   margin-left: -5px;
	}
}
.navigation_div_2,
.navigation_div_3{
  background: 
  linear-gradient(45deg,transparent 12px,#999 0) top left,
  linear-gradient(135deg,transparent 12px,#999 0) bottom left,
  linear-gradient(-45deg,transparent 12px,#999 0) bottom right,
  linear-gradient(-135deg,transparent 12px,#999 0) top right !important;
  background-size: 80% 50.1% !important;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  padding: 0px 0px !important;
  .nav_text{
      margin-left: 7px;
  }
}
.navigation_div_4{
  color: #ffffff;
  background: 
  linear-gradient(45deg, transparent 24px, #999 0) bottom right,
  linear-gradient(135deg, transparent 24px, #999 0) top right !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  padding: 0 0px 0px 0px!important;
  .nav_text{
      margin-left: 10px;
  }
}

.navigation_div_1_select{
  background: 
	linear-gradient(135deg, transparent 0px, #169BD5 0) top left,
   linear-gradient(45deg, transparent 0px, #169BD5 0) bottom left,
   linear-gradient(-45deg, transparent 12px, #169BD5 0) bottom right,
   linear-gradient(-135deg, transparent 12px, #169BD5 0) top right !important;
   background-size: 80% 50.1% !important;
   background-repeat: no-repeat !important;
   box-sizing: border-box;
   padding: 0 0px 0px 0px!important;
	.nav_text{
	   margin-left: -5px;
	}
}
.navigation_div_2_select,
.navigation_div_3_select{
  background: 
  linear-gradient(45deg,transparent 12px,#169BD5 0) top left,
  linear-gradient(135deg,transparent 12px,#169BD5 0) bottom left,
  linear-gradient(-45deg,transparent 12px,#169BD5 0) bottom right,
  linear-gradient(-135deg,transparent 12px,#169BD5 0) top right !important;
  background-size: 80% 50.1% !important;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  padding: 0px 0px !important;
  .nav_text{
      margin-left: 7px;
  }
}
.navigation_div_4_select{
  color: #ffffff;
  background: 
  linear-gradient(45deg, transparent 24px, #169BD5 0) bottom right,
  linear-gradient(135deg, transparent 24px, #169BD5 0) top right !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  padding: 0 0px 0px 0px!important;
  .nav_text{
      margin-left: 10px;
  }
}

@media only screen and (min-width: 768px) {
  .nav_text{
     font-size: 13px;
     font-family: Poppins-SemiBold, Poppins;
     font-weight: 600;
     line-height: 15px;
  }
}

@media only screen and (min-width: 900px) {
  .nav_text{
     font-size: 14px;
     font-family: Poppins-SemiBold, Poppins;
     font-weight: 600;
     line-height: 15px;
  }
}
</style>
